import { useInfiniteQuery } from '@tanstack/react-query';

import { customersApi } from '../api/customers-api';

import { customerKeys } from './customer-keys';

const PAGE_SIZE = 20;

/** Customer changes, order events and privacy requests, newest first, a page at a time. */
export function useCustomerTimeline(storeId: string, id: string) {
  return useInfiniteQuery({
    queryKey: customerKeys.timeline(storeId, id),
    queryFn: ({ pageParam }) =>
      customersApi.timeline(
        storeId,
        id,
        pageParam ? { limit: PAGE_SIZE, cursor: pageParam } : { limit: PAGE_SIZE },
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
}
